import { isDefined } from '../type';
import { each } from '../iterator';
import { orderEach } from '../object/object';
/**
 * 
 * @param {Array} entity 
 * @returns {Boolean}
 */

export const isEmpty = entity => Array.isArray(entity) && !entity.length;
/**
 * 
 * @param {any} entity 
 * @returns {Array} [entity]
 */

export const wrapToArray = entity => Array.isArray(entity) ? entity : [entity];
/**
 * 
 * @param {*} value in object 
 * @param {ArrayLike} object is a array-like object
 * @returns {Number} index of value, -1 if not found
 */

export const inArray = (value, object) => {
  if (!object) return -1;
  const array = Array.isArray(object) ? object : Array.from(object);
  return array.indexOf(value);
};
/**
 * 
 * @param {Array} a 
 * @param {Array} b 
 * @returns {Array} intersection array of a and b
 */

export const intersection = (a, b) => {
  if (!Array.isArray(a) || a.length === 0 || !Array.isArray(b) || b.length === 0) return [];
  const result = [];
  each(a, (_, value) => {
    const index = inArray(value, b);

    if (index !== -1) {
      result.push(value);
    }
  });
  return result;
};
/**
 * 
 * @param {Array} data 
 * @returns {Array} array with unique values
 */

export const uniqueValues = data => data.filter((item, position) => data.indexOf(item) === position);
/**
 * 
 * @param {Array} from 
 * @param {Array} what 
 * @returns {Array} without duplicate
 */

export const removeDuplicates = function (from, what) {
  if (!Array.isArray(from) || from.length === 0) {
    return [];
  }

  if (!Array.isArray(what) || what.length === 0) {
    return from.slice();
  }

  const result = [];
  each(from, (_, value) => {
    const index = inArray(value, what);

    if (index === -1) {
      result.push(value);
    }
  });
  return result;
};
/**
 * 
 * @param {Array} items 
 * @param {*} indexParameterName 
 * @param {*} currentItem 
 * @param {Function} needIndexCallback 
 * @returns 
 */

export const normalizeIndexes = function (items, indexParameterName, currentItem, needIndexCallback) {
  const indexedItems = {};
  let parameterIndex = 0;
  /**
   * useLegacyVisibleIndex will be process in future
   */

  const useLegacyVisibleIndex = false;
  each(items, (index, item) => {
    index = item[indexParameterName];

    if (index >= 0) {
      indexedItems[index] = indexedItems[index] || [];

      if (item === currentItem) {
        indexedItems[index].unshift(item);
      } else {
        indexedItems[index].push(item);
      }
    } else {
      item[indexParameterName] = undefined;
    }
  });

  if (!useLegacyVisibleIndex) {
    each(items, function () {
      if (!isDefined(this[indexParameterName]) && !!needIndexCallback && needIndexCallback(this)) {
        while (indexedItems[parameterIndex]) {
          parameterIndex++;
        }

        indexedItems[parameterIndex] = [this];
        parameterIndex++;
      }
    });
  }

  parameterIndex = 0;
  orderEach(indexedItems, function (index, items) {
    each(items, function () {
      if (index >= 0) {
        this[indexParameterName] = parameterIndex++;
      }
    });
  }); // if (useLegacyVisibleIndex) {
  // 	each(items, function () {
  // 		if (
  // 			!isDefined(this[indexParameterName]) &&
  // 			(!needIndexCallback || needIndexCallback(this))
  // 		) {
  // 			this[indexParameterName] = parameterIndex++;
  // 		}
  // 	});
  // }

  return parameterIndex;
};
export const merge = function (array1, array2) {
  for (let i = 0; i < array2.length; i++) {
    array1[array1.length] = array2[i];
  }

  return array1;
};
export const find = function (array, condition) {
  for (let i = 0; i < array.length; i++) {
    if (condition(array[i])) {
      return array[i];
    }
  }
};
export const groupByFunc = (array, cb) => array.reduce((result, item) => ({ ...result,
  [cb(item)]: [...(result[cb(item)] || []), item]
}), {});
export const groupByKey = (array, key) => array.reduce((result, item) => {
  (result[item[key]] = result[item[key]] || []).push(item);
  return result;
}, {});
export const isEqual = (currentArray, compareArray) => {
  if (!currentArray || !compareArray) return false;
  if (currentArray.length !== compareArray.length) return false;

  for (let i = 0, j = currentArray.length; i < j; i++) {
    if (currentArray[i] instanceof Array && compareArray[i] instanceof Array) {
      if (!isEqual(currentArray[i], compareArray[i])) {
        return false;
      }
    } else if (currentArray[i] !== compareArray[i]) {
      return false;
    } // in future will update for object case
    // else if (typeof currentArray[i] === 'object' && typeof compareArray[i] === 'object') {}

  }

  return true;
};